const style = {
  list: {
    paddingTop: '94px',
    background: '#ffffff',
    border: '1px solid #c4c4c4',
    borderRight: '0px',
    minWidth: '196px',
    width: '100%',
    '&:last-child': {
      borderRight: '1px solid #c4c4c4',
    },
  },
}

export default style



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/style.js